module.exports = __webpack_public_path__ + "img/neet.ae432273.png";